import React from 'react';
import './LoadingSpinner.css';

/**
 * LoadingSpinner component - shows during lazy-loaded component loading
 * Supports both light and dark themes
 */

interface LoadingSpinnerProps {
  message?: string;
  fullScreen?: boolean;
}

function LoadingSpinner({ message = 'Loading...', fullScreen = true }: LoadingSpinnerProps) {
  return (
    <div className={`loading-spinner-container ${fullScreen ? 'loading-spinner-fullscreen' : ''}`}>
      <div className="loading-spinner-content">
        <div className="loading-spinner-circle"></div>
        <p className="loading-spinner-message">{message}</p>
      </div>
    </div>
  );
}

export default LoadingSpinner;
export type { LoadingSpinnerProps };
